import apiClient from '../api/client';

const API_BASE =
  apiClient.defaults.baseURL ||
  (window.location.hostname === 'qtf.iniserve.com'
    ? 'https://qtf.iniserve.com'
    : window.location.origin);

/**
 * Turn stored upload paths (/uploads/...) into absolute URLs on the API host.
 * Leaves http(s) and data: URLs unchanged.
 */
export function resolveUploadUrl(path) {
  if (!path) return null;
  const s = String(path).trim();
  if (!s) return null;
  if (
    s.startsWith('http://') ||
    s.startsWith('https://') ||
    s.startsWith('data:')
  ) {
    return s;
  }
  const base = API_BASE.replace(/\/$/, '');
  const rel = s.startsWith('/') ? s : `/${s}`;
  return `${base}${rel}`;
}

export default resolveUploadUrl;
